import model from '@/model/push';

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign,func-names
    Vue.prototype.$push = function (push) {
      model.add(push);
    };
  },
};
